import { Navigate, Route, Routes } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import CalendarPage from "@/pages/CalendarPage";
import Customers from "@/pages/Customers";
import CustomerDetail from "@/pages/CustomerDetail";
import ServicesPage from "@/pages/ServicesPage";
import Settings from "@/pages/Settings";
import Emails from "@/pages/Emails";
import Vehicles from "@/pages/Vehicles";
import VehicleDetail from "@/pages/VehicleDetail";
import Jobs from "@/pages/Jobs";
import JobDetail from "@/pages/JobDetail";
import Invoices from "@/pages/Invoices";
import InvoiceDetail from "@/pages/InvoiceDetail";
import Payments from "@/pages/Payments";
import Steuer from "@/pages/Steuer";
import Archive from "@/pages/Archive";
import StartupRedirect from "@/components/StartupRedirect";
import PinGuard from "@/components/PinGuard";
import WorkshopMode from "@/pages/WorkshopMode";
import Notes from "@/pages/Notes";
import Layout from "@/components/Layout";

function Protected({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="flex h-screen items-center justify-center text-muted-foreground">Laden…</div>;
  if (!user) return <Navigate to="/login" replace />;
  return <Layout>{children}</Layout>;
}

export default function App() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/" element={<Protected><StartupRedirect /></Protected>} />
      <Route path="/dashboard" element={<Protected><PinGuard><Dashboard /></PinGuard></Protected>} />
      <Route path="/kalender" element={<Protected><CalendarPage /></Protected>} />
      <Route path="/kunden" element={<Protected><Customers /></Protected>} />
      <Route path="/kunden/:id" element={<Protected><CustomerDetail /></Protected>} />
      <Route path="/fahrzeuge" element={<Protected><Vehicles /></Protected>} />
      <Route path="/fahrzeuge/:id" element={<Protected><VehicleDetail /></Protected>} />
      <Route path="/auftraege" element={<Protected><Jobs /></Protected>} />
      <Route path="/auftraege/:id" element={<Protected><JobDetail /></Protected>} />
      <Route path="/rechnungen" element={<Protected><PinGuard><Invoices /></PinGuard></Protected>} />
      <Route path="/rechnungen/:id" element={<Protected><PinGuard><InvoiceDetail /></PinGuard></Protected>} />
      <Route path="/zahlungen" element={<Protected><PinGuard><Payments /></PinGuard></Protected>} />
      <Route path="/steuer" element={<Protected><PinGuard><Steuer /></PinGuard></Protected>} />
      <Route path="/archiv" element={<Protected><PinGuard><Archive /></PinGuard></Protected>} />
      <Route path="/notizen" element={<Protected><PinGuard><Notes /></PinGuard></Protected>} />
      <Route path="/dienste" element={<Protected><ServicesPage /></Protected>} />
      <Route path="/emails" element={<Protected><Emails /></Protected>} />
      <Route path="/einstellungen" element={<Protected><Settings /></Protected>} />
      <Route path="/werkstatt" element={<Protected><WorkshopMode /></Protected>} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
